import { confirm, show } from '@/services/messages/messageService';

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $confirmMessage: {
        get: () => confirm,
      },
      $showMessage: {
        get: () => show,
      },
    });
  },
};
